/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Missiontitle1Inputs */

const id_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misi Kami`)
};

const ms_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misi Kami`)
};

const da_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vores Mission`)
};

const de_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsere Mission`)
};

const en_us2_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Mission`)
};

const es_es2_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuestra misión`)
};

const es_mx2_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuestra misión`)
};

const fil_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aming Misyon`)
};

const fr_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notre mission`)
};

const it_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La nostra missione`)
};

const hu_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Küldetésünk`)
};

const nl_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onze missie`)
};

const no_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vår misjon`)
};

const pl_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasza misja`)
};

const pt_br2_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nossa Missão`)
};

const pt_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A nossa missão`)
};

const ro_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misiunea noastră`)
};

const fi_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tehtävämme`)
};

const sv_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vårt uppdrag`)
};

const vi_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sứ mệnh của chúng tôi`)
};

const tr_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misyonumuz`)
};

const cs_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naše mise`)
};

const bg_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нашата мисия`)
};

const ru_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наша миссия`)
};

const uk_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наша місія`)
};

const ar_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مهمتنا`)
};

const hi_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमारा मिशन`)
};

const th_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พันธกิจของเรา`)
};

const ja_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私たちの使命`)
};

const zh_cn2_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们的使命`)
};

const zh_hant1_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們的使命`)
};

const ko_about_missiontitle1 = /** @type {(inputs: About_Missiontitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`우리의 사명`)
};

/**
* | output |
* | --- |
* | "Our Mission" |
*
* @param {About_Missiontitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_missiontitle1 = /** @type {((inputs?: About_Missiontitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Missiontitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_missiontitle1(inputs)
	if (locale === "ms") return ms_about_missiontitle1(inputs)
	if (locale === "da") return da_about_missiontitle1(inputs)
	if (locale === "de") return de_about_missiontitle1(inputs)
	if (locale === "en-US") return en_us2_about_missiontitle1(inputs)
	if (locale === "es-ES") return es_es2_about_missiontitle1(inputs)
	if (locale === "es-MX") return es_mx2_about_missiontitle1(inputs)
	if (locale === "fil") return fil_about_missiontitle1(inputs)
	if (locale === "fr") return fr_about_missiontitle1(inputs)
	if (locale === "it") return it_about_missiontitle1(inputs)
	if (locale === "hu") return hu_about_missiontitle1(inputs)
	if (locale === "nl") return nl_about_missiontitle1(inputs)
	if (locale === "no") return no_about_missiontitle1(inputs)
	if (locale === "pl") return pl_about_missiontitle1(inputs)
	if (locale === "pt-BR") return pt_br2_about_missiontitle1(inputs)
	if (locale === "pt") return pt_about_missiontitle1(inputs)
	if (locale === "ro") return ro_about_missiontitle1(inputs)
	if (locale === "fi") return fi_about_missiontitle1(inputs)
	if (locale === "sv") return sv_about_missiontitle1(inputs)
	if (locale === "vi") return vi_about_missiontitle1(inputs)
	if (locale === "tr") return tr_about_missiontitle1(inputs)
	if (locale === "cs") return cs_about_missiontitle1(inputs)
	if (locale === "bg") return bg_about_missiontitle1(inputs)
	if (locale === "ru") return ru_about_missiontitle1(inputs)
	if (locale === "uk") return uk_about_missiontitle1(inputs)
	if (locale === "ar") return ar_about_missiontitle1(inputs)
	if (locale === "hi") return hi_about_missiontitle1(inputs)
	if (locale === "th") return th_about_missiontitle1(inputs)
	if (locale === "ja") return ja_about_missiontitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_about_missiontitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_missiontitle1(inputs)
	return ko_about_missiontitle1(inputs)
});
export { about_missiontitle1 as "about.missionTitle" }